/**
 * WTC company owners / partners — the canonical CC/BCC list for "copy the
 * owners" features (compose email modal "Include Internal Team", Slack ticket
 * quick-reply email CC, etc.). Kept in `lib/` so both client components and
 * server-side Slack handlers can import it.
 */
export const COMPANY_PARTNERS_EMAILS = [
  "eliza.keffeler@westtn.consulting",
  "charliekeffeler@westtn.consulting",
  "miclainkeffeler@westtn.consulting",
];
